const colors = {
  primary: "#37D7B7",
  secondary: "#89319D",
};

export { colors };
